/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateCustomNotificationDTO,
    CreateCustomNotificationResponse,
    CreateGlobalMessageDto,
} from '../models';

export interface NotificationApiControllerCreateCustomNotificationRequest {
    createCustomNotificationDTO: CreateCustomNotificationDTO;
}

export interface NotificationApiControllerCreateGlobalMessageRequest {
    createGlobalMessageDto: CreateGlobalMessageDto;
}

export interface NotificationApiControllerDeleteCustomNotificationRequest {
    notificationId: string;
}

export interface NotificationApiControllerReadNotificationRequest {
    sellerId: string;
    sellerAdminNotificationId: string;
}

/**
 * 
 */
export class NotificationApi extends runtime.BaseAPI {

    /**
     * create custom notification
     */
    async notificationApiControllerCreateCustomNotificationRaw(requestParameters: NotificationApiControllerCreateCustomNotificationRequest): Promise<runtime.ApiResponse<CreateCustomNotificationResponse>> {
        if (requestParameters.createCustomNotificationDTO === null || requestParameters.createCustomNotificationDTO === undefined) {
            throw new runtime.RequiredError('createCustomNotificationDTO','Required parameter requestParameters.createCustomNotificationDTO was null or undefined when calling notificationApiControllerCreateCustomNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/custom-notifications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCustomNotificationDTO,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * create custom notification
     */
    async notificationApiControllerCreateCustomNotification(requestParameters: NotificationApiControllerCreateCustomNotificationRequest): Promise<CreateCustomNotificationResponse> {
        const response = await this.notificationApiControllerCreateCustomNotificationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async notificationApiControllerCreateGlobalMessageRaw(requestParameters: NotificationApiControllerCreateGlobalMessageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createGlobalMessageDto === null || requestParameters.createGlobalMessageDto === undefined) {
            throw new runtime.RequiredError('createGlobalMessageDto','Required parameter requestParameters.createGlobalMessageDto was null or undefined when calling notificationApiControllerCreateGlobalMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-messages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createGlobalMessageDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async notificationApiControllerCreateGlobalMessage(requestParameters: NotificationApiControllerCreateGlobalMessageRequest): Promise<void> {
        await this.notificationApiControllerCreateGlobalMessageRaw(requestParameters);
    }

    /**
     */
    async notificationApiControllerDeleteCustomNotificationRaw(requestParameters: NotificationApiControllerDeleteCustomNotificationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.notificationId === null || requestParameters.notificationId === undefined) {
            throw new runtime.RequiredError('notificationId','Required parameter requestParameters.notificationId was null or undefined when calling notificationApiControllerDeleteCustomNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/custom-notifications/{notificationId}`.replace(`{${"notificationId"}}`, encodeURIComponent(String(requestParameters.notificationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async notificationApiControllerDeleteCustomNotification(requestParameters: NotificationApiControllerDeleteCustomNotificationRequest): Promise<void> {
        await this.notificationApiControllerDeleteCustomNotificationRaw(requestParameters);
    }

    /**
     */
    async notificationApiControllerReadNotificationRaw(requestParameters: NotificationApiControllerReadNotificationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling notificationApiControllerReadNotification.');
        }

        if (requestParameters.sellerAdminNotificationId === null || requestParameters.sellerAdminNotificationId === undefined) {
            throw new runtime.RequiredError('sellerAdminNotificationId','Required parameter requestParameters.sellerAdminNotificationId was null or undefined when calling notificationApiControllerReadNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/seller-admin-notifications/{sellerAdminNotificationId}:read`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"sellerAdminNotificationId"}}`, encodeURIComponent(String(requestParameters.sellerAdminNotificationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async notificationApiControllerReadNotification(requestParameters: NotificationApiControllerReadNotificationRequest): Promise<void> {
        await this.notificationApiControllerReadNotificationRaw(requestParameters);
    }

}
